export function err2str(error) {
	return error.response
		? (error.response.data.message || error.response.data.error)
		: error.toString()
}

export function dbr(x) {
	return (parseFloat(x) / 1000000000).toFixed(9)
}

export function dbr2usd(x) {
	return (parseFloat(x) / 4000000).toFixed(2)
}

export function offset(el) {
	const rect = el.getBoundingClientRect()
	const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || 0
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

export function idx2color(idx) {
	const strokeOpacity = 1
	const fillOpacity = 0.25

	return [
		'249, 144, 24', // rgba(249, 144, 24, 1)
		'19, 158, 239', // rgba(19, 158, 239, 1)
		'255, 68, 192', // rgba(255, 68, 192, 1)
		'18, 237, 186', // rgba(18, 237, 186, 1)
		'252, 204, 32', // rgba(252, 204, 32, 1)
		'188, 25, 252', // rgba(188, 25, 252, 1)
		'188, 25, 252', // rgba(188, 25, 252, 1)
		'188, 25, 252', // rgba(188, 25, 252, 1)
		'188, 25, 252', // rgba(188, 25, 252, 1)
	].map(color => ({
		stroke: `rgba(${color}, ${strokeOpacity})`,
		fill: `rgba(${color}, ${fillOpacity})`,
		strokeWidth: 2,
		fontSize: 16,
	}))[idx]
}

export const debounce = (func, wait, immediate) => {
	let timeout
	return (...args) => {
		const context = this
		const later = () => {
			timeout = null
			if (!immediate) func.apply(context, args)
		}
		const callNow = immediate && !timeout
		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
		if (callNow) func.apply(context, args)
	}
}

export const throttle = (func, ms) => {
	/* eslint-disable */
	let isThrottled = false
	let savedArgs
	let savedThis

	function wrapper() {
		if (isThrottled) {
			savedArgs = arguments
			savedThis = this
			return
		}

		func.apply(this, arguments)

		isThrottled = true

		setTimeout(() => {
			isThrottled = false
			if (savedArgs) {
				wrapper.apply(savedThis, savedArgs)
				savedArgs = savedThis = null
			}
		}, ms)
	}

	return wrapper
	/* eslint-enable */
}

export const path2svg = (x0, y0, path, notClose) => {
	let minX
	let minY
	let maxX
	let maxY
	const points = path.map((point, i) => {
		let { x, y } = point
		x += x0
		y += y0
		if (i === 0) {
			minX = x
			maxX = x
			minY = y
			maxY = y
			return `M${x} ${y}`
		}
		minX = Math.min(minX, x)
		minY = Math.min(minY, y)
		maxX = Math.max(maxX, x)
		maxY = Math.max(maxY, y)
		return `L${x} ${y}`
	})
	return {
		x: minX,
		y: minY,
		width: maxX - minX,
		height: maxY - minY,
		path: `${points.join(' ')}${notClose ? '' : ' Z'}`,
	}
}

export const getX = e => (e.clientX || (e.touches && e.touches.length && e.touches[0].clientX) || 0) + window.scrollX

export const getY = e => (e.clientY || (e.touches && e.touches.length && e.touches[0].clientY) || 0) + window.scrollY

export const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints
export const getDeviceType = () => {
	let type = 'desktop'
	if (window.innerWidth <= 600) {
		type = 'mobile'
	} else if (window.innerWidth <= 768) {
		type = 'tablet'
	}
	return type
}

export const setNoScroll = (noScroll) => {
	if (noScroll) {
		document.body.classList.add('no-scroll')
	} else {
		document.body.classList.remove('no-scroll')
	}
}

export const taskPathToArray = (array, factor = [1, 1]) => (
	array.map((point, num) => {
		const n = num % 2 ? factor[0] : factor[1]

		return [point.rx * n, point.ry * n]
	})
)

export const denormalizeArray = (array, size) => (
	array.map(item => (
		{
			rx: item[0],
			ry: item[1],
			x: item[0] * size[0],
			y: item[1] * size[1],
		}
	))
)

export const isEqualsObjKeys = (obj1, obj2) => {
	if (!obj1 || !obj2) return false

	const o1Keys = Object.keys(obj1)
	const o2Keys = Object.keys(obj2)

	if (o1Keys.length !== o2Keys.length) return false

	return o1Keys.toString() === o2Keys.toString()
}

export const replaceAll = (target, search, replacement) => (
	target.replace(new RegExp(search, 'g'), replacement)
)

export const clearHightlightedText = () => {
	if (window.getSelection) {
		if (window.getSelection().empty) {
			window.getSelection().empty()
		} else
		if (window.getSelection().removeAllRanges) {
			window.getSelection().removeAllRanges()
		}
	} else
	if (document.selection) {
		document.selection.empty()
	}
}
